export default __webpack_public_path__ + "7c8ba823e6ad9d4a69974b337e286274.svg";